
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.106 8.265l3.232-3.227-.173-.172.733-.73-1.065-1.064-.732.731-.173-.172-.133.133c-.462-.916-.376-2.035.452-3.448C3.223-1.297-1.119 3.596.274 7.434c1.304-.757 2.65-1.08 3.653-.806l-.23.23.172.172L0 10.893V12h1.021l3.913-3.907.173.172zm6.577-3.52c-1.435.839-2.564.919-3.488.436L5.352 8.02c.295 1.006-.029 2.367-.798 3.688 3.844 1.39 8.745-2.944 7.13-6.962z"}})])
          )
        }
      }
    